// @flow
import * as ActionTypes from "../actions/actionTypes";
import type { AxiosPromise } from "axios";
import type { SitePageContentTypesEnum, SitePagePositionsEnum, SiteLinkTypes, SiteLinkOpenTargetEnum, LookupStatus, RewardType, RewardTrigger, ReferralStatus } from "../common/enums";

export class EntityList<T> {
    items: Array<T>;
    totalPages: number;
    totalRecords: number;
    constructor(items: Array<T>, totalPages: number, totalRecords: number) {
        this.items = items;
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;
    }
}


export class Order {
    totalDeliveryFees: string;
    totalCustomerPrice: string;
    dispatchedAt: Date;
    orderedAt: Date;
    status: string;
    refundStatus: string;
    id: number;
    supplierId: number;
}

export class OrderResponse {
    requiresActionExternalRedirect: boolean;
    paymentProviderRedirectURL: string;
    newOrderId: number;

    failedExternalRedirectSVerification: boolean;
    constructor() {
        this.requiresActionExternalRedirect = false;
        this.paymentProviderRedirectURL = '';
        this.newOrderId = 0;
        this.failedExternalRedirectSVerification = false;
    }
}

export class OpenpayPlan {
    id: string;
    status: string;
}


export class Translation {
    resourceId: string;
    value: string;
    localeId: string;
}


export class Page {
    id: number;
    content: string;
    contentType: number;
    name: string;
    description: string;
    notFound: boolean;
    constructor() {
        this.id = 0;
        this.content = "";
        this.contentType = 0;
        this.name = "";
        this.description = "";
        this.notFound = false;
    }
}

export class Product {
    title: string;
    groupId: number;
    groupName: string;
    isFeatured: true;
    zoneId: number;
    zoneName: string;
    drop: string;
    thumbnail: string;
    images: Array<string>;
    mobileVideo: string;
    desktopVideo: string;
    specialPrice: number;
    originalPrice: number;
    hasSingleStock: true;
    stockItemId: number;
    stockItemCode: string;
    benefit1: string;
    benefit2: string;
    benefitOverview: string;
    hint: string;
    usage: string;
    notes: string;
    id: number;
    supplierId: number;
}

export class Group {
    id: number;
    name: string;
    supplierId: number;
}

export class Item {
    id: number;
    name: string;
}


export class Settings {
    currencySymbol: string;
    isoCode: string;
    pageSize: number;
    deliveryCharge: number;
    deliveryServiceId: number;
    email: string;
    facebookUrl: string;
    instagramUrl: string;
    telephone: string;
    twitterUrl: string;
    youtubeUrl: string;
    deliveryRegions: Array<Item>;
    titles: Array<Item>;
    defaultImageUrl: string;
    shortDatePattern: string;
    baseUrl: string;
    shopName: string;
    supplierId: number;
    supplierCode: String;
    constructor(
        currencySymbol: string,
        pageSize: number,
        deliveryCharge: number,
        deliveryServiceId: number,
        defaultImageUrl: string,
        shortDatePattern: string
    ) {
        this.pageSize = pageSize;
        this.currencySymbol = currencySymbol;
        this.deliveryCharge = deliveryCharge;
        this.deliveryServiceId = deliveryServiceId;
        this.defaultImageUrl = defaultImageUrl;
        this.shortDatePattern = shortDatePattern;

    }
}

export class SiteLink {
    ContentType: SitePageContentTypesEnum;
    Position: SitePagePositionsEnum;
    SiteLinkTypes: SiteLinkTypes;
    IsRelativeUrl: boolean;
    UseRepresentativeEmail: boolean;
    Content: string;
    ContentUrl: string;
    Locale: string;
    Name: string;
    Sequence: number;
    Description: string;
    Status: LookupStatus;
    Target: SiteLinkOpenTargetEnum;
}


export class Promotion {
    id: number;
    imageUrl: string;
    originalPrice: number;
    specialPrice: number;
    title: string;
    targetUrl: string;
    productId: number;
}

export class SliderItem {
    id: number;
    imageUrl: string;
    originalPrice: number;
    specialPrice: number;
    title: string;
    targetUrl: string;
    productId: number;
}

export class PagerSettings {
    activePage: number;
    totalPages: number;

    constructor(activePage: number, totalPages: number) {
        this.totalPages = totalPages;
        this.activePage = activePage;
    }
}

export class Representative {
    id: number;
    name: string;
    address: string;
    imageUrl: string;
    status: number;
    mobile: string;
    phone: string;
    supplierId: number;
    email: string;
    facebookUrl: string;
    instagramUrl: string;
    telephone: string;
    twitterUrl: string;
    youtubeUrl: string;
    startedAt: string;
    isWebshopOwner: boolean;
    bestTimeToCall: string;
    address4: string;
}

export class User {
    //constructor(representative: Representative) {
    //    this.representative = representative;
    //    this.isAuthenticated = false;
    //    this.accessToken = '';
    //    this.isNewsletterSubscriber = false;
    //}
    id: number;
    name: string;
    accessToken: string;
    expiresIn: string;
    tokenType: number;
    refreshToken: string;
    isAuthenticated: boolean;
    representative: Representative;
    isPasswordReset: boolean;
    isAccountCreated: boolean;
    isCustomerExists: boolean;
    isProfileSaved: boolean;
    email: string;
    phone: string;
    mobile: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    postCode: string;
    regionId: number;
    title: number;
    imageUrl: string;
    createdAt:Date;
    totalOrdersCount: number;
    activeTotalPoints: number;
    locale: string;
    referralCode: string;
}

export class Cart {
    id: number;
    name: string;
    isDefault: boolean;
    userId: string;
    lines: Array<CartItem>;
    saveAfterCartMerge: boolean;
    constructor(
        id: number,
        name: number,
        isDefault: boolean,
        userId: number,
        saveAfterCartMerge: boolean
    ) {
        this.id = id;
        this.name = name;
        this.userId = userId;
        this.isDefault= isDefault;
        this.lines = [];
        this.saveAfterCartMerge = false;
    }
}

export class CartItem {
    product: Product;
    quantity: number;
    price: number;
    stockItemId: number;

    constructor(
        product: Product,
        quantity: number,
        stockItemId: number,
        originalPrice: number,
        specialPrice: number
    ) {
        this.product = product;
        this.quantity = quantity;
        this.originalPrice = originalPrice;
        this.specialPrice = specialPrice;
        this.stockItemId = stockItemId;
    }
}

export class State {
    groups: Array<Group>;
    products: Array<Product>;
    featuredProducts: Array<Product>;
    cart: Cart;
    wishlist: Array<Product>;
    activePage: number;
    selectedProduct: Product;
    settings: Settings;
}

export class AllCustomerReferrals {
    customerReferrals: Array<ReferralActionLog>;
    customerRefereeActionLog: ReferralActionLog;
}

export class ReferralActionLog {
    referralDate: Date;
    referralStatus: ReferralStatus;

    // Referee Info
    refereeFullName: string;

    // Referral Program Setting Info
    referralProgramName: string;
    referralProgramIsDeleted: Boolean;
    programExpiryDate: Date;
    rewardType: RewardType;
    rewardTrigger: RewardTrigger;

    // Discount Code Info
    discountCode: string;
    discountCodeAmountType: string;
    discountValue: number;
    LimitNumberToBeUsedInTotal: number;
    DiscountCodeStartDate: Date;
    DiscountCodeEndDate: Date;

    // points // Not Handled yet, No way to set it.
    ReferrerPointsValue: number;
}

//******************************This is for later to introduce flow into redux. problem with axios promise type********************************
type GetProductsAction = {
  +type: "GET_PRODUCTS_FULFILLED",
    payload: AxiosPromise<any, any> //AxiosPromise<any>
};
type GetProductAction = {
  +type: ActionTypes.GET_PRODUCT,
    payload: Product
};
type SetActivePageAction = {
  +type: ActionTypes.SET_ACTIVE_PAGE,
    payload: number
};
type SetPageSizeAction = {
  +type: ActionTypes.SET_PAGE_Size,
    payload: number
};
type GetGroupsAction = {
  +type: "GET_GROUPS_FULFILLED",
    payload: AxiosPromise<any, any>
};
type GetFeaturedProductsAction = {
  +type: ActionTypes.GET_FEATURED_PRODUCTS,
    payload: AxiosPromise<any>
};
type AddToCartAction = {
  +type: ActionTypes.ADD_TO_CART,
    payload: { product: Product, quantity: number }
};
type GetRemoveFromCartAction = {
  +type: ActionTypes.REMOVE_FROM_CART,
    payload: number
};
type AddToWishlistAction = {
  +type: ActionTypes.ADD_TO_WISHLIST,
    payload: Product
};
type RemoveFromWishlistAction = {
  +type: ActionTypes.REMOVE_FROM_WISHLIST,
    payload: number
};
type UpdateCartAction = {
  +type: ActionTypes.UPDATE_CART,
    payload: { product: Product, quantity: number }
};
type EmptyCartAction = { +type: ActionTypes.EMPTY_CART, payload: null };
type GetActiveSettingsAction = {
  +type: ActionTypes.GET_ACTIVE_SETTINGS,
    payload: Settings
};

export type Action =
    | GetProductsAction
    | GetProductAction
    | SetActivePageAction
    | SetPageSizeAction
    | GetGroupsAction
    | GetFeaturedProductsAction
    | AddToCartAction
    | GetRemoveFromCartAction
    | AddToWishlistAction
    | RemoveFromWishlistAction
    | UpdateCartAction
    | EmptyCartAction
    | GetActiveSettingsAction;

export class Error {
    isRequestRejected: boolean;
    actionType: Action;
    id: string;
    message: string;
    type: string;
    moduleCode: string;
    showMessageToUser: string;
    extraInformation: string;


    constructor(isRequestRejected: boolean, id: string, message: string, type: string, moduleCode: string, showMessageToUser: string, extraInformation: string, actionType: Action) {
        this.isRequestRejected = isRequestRejected;
        this.id = id;
        this.message = message;
        this.type = type;
        this.moduleCode = moduleCode;
        this.actionType = actionType;
        this.showMessageToUser = showMessageToUser;
        this.extraInformation = extraInformation;
    }
}